import { Util } from '@h3/h3common';
import { H3 } from '@h3/types';

const isMaster = location.host.startsWith('master');

const AgentList: H3.AI.AIAgent.IAgentModel[] = [
    {
        id: 'H3_AGENT_FORM_FILL_ASSISTANT',
        name: '智能填单助手',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_8.svg',
        description: '具备多模态的自动识别与填单能力。支持根据用户输入的文本、语音、图片及文件自动提取关键信息。',
        type: 0,
        isUserToggleable: false,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'info-extraction',
                name: '信息提取',
            },
            {
                id: 'smart-mapping',
                name: '智能映射',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'H3_AGENT_DATA_ANALYST',
        name: '智能数据分析师',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_2.svg',
        description:
            '提供业务数据的多维归因分析能力。支持用户通过自然语言与数据交互，快速完成跨维度指标查询及异常分析。',
        type: 0,
        isUserToggleable: false,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'conversational-query',
                name: '对话查数',
            },
            {
                id: 'attribution-analysis',
                name: '归因分析',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'H3_AGENT_TEXT_ANALYST',
        name: '智能文本分析专家',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_3.svg',
        description: '提供基于深度语义理解的综合文本处理能力。支持对文本内容进行多维逻辑分级及核心观点提炼。',
        type: 0,
        isUserToggleable: false,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'classification',
                name: '分类',
            },
            {
                id: 'summarization',
                name: '总结',
            },
            {
                id: 'translation',
                name: '翻译',
            },
            {
                id: 'refinement',
                name: '润色',
            },
            {
                id: 'extraction',
                name: '信息提取',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'H3_AGENT_RECOGNITION_ASSISTANT',
        name: 'AI识别助手',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_4.svg',
        description: '具备高精度的OCR文字识别与图像理解能力。支持快速提取证件、发票、合同扫描件中的关键字段。',
        type: 0,
        isUserToggleable: false,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'credential-recognition',
                name: '卡证识别',
            },
            {
                id: 'general-ocr',
                name: '通用OCR',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'H3_AGENT_REPORT_GENERATE_EXPERT',
        name: '分析报告专家',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_1.svg',
        description: '根据数据与模板自动生成结构化报告，支持多种输出格式与定制化模版。',
        type: 0,
        isUserToggleable: true,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'report-generation',
                name: '报告生成',
            },
            {
                id: 'analysis-suggestion',
                name: '分析建议',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'H3_AGENT_ATTACHMENT_PARSER',
        name: '附件解析助手',
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_item_1.svg',
        description:
            '基于多模态理解的附件内容解析能力。支持文档、表格、图片等多类型文件的要点提炼与结构化抽取，适用于合同审阅、简历审核、会议纪要等场景。',
        type: 0,
        isUserToggleable: true,
        isExternal: false,
        enabled: true,
        skills: [
            {
                id: 'file-recognition',
                name: '附件总结',
            },
            {
                id: 'contract-recognition',
                name: '合同评审',
            },
            {
                id: 'resume-parsing',
                name: '简历评估',
            },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
    },
    {
        id: 'chat_analysis_agent',
        name: '客户跟进分析助理',
        description:
            '提供基于真实沟通记录的可验证客户分析能力。支持通过自然语言完成客户盘点/统计、客户跟进深挖与需求分析，所有事实性结论均回链至原始对话证据。',
        type: 0,
        thumbnail: 'https://static.h3yun.com/common-resource/pc/ai/agent/ai_agent_chat_analysis.svg',
        isUserToggleable: false,
        isExternal: true,
        enabled: true,
        skills: [
            { id: Util.Random.getRandom8(), name: '证据回链' },
            { id: Util.Random.getRandom8(), name: '对话查数' },
            { id: Util.Random.getRandom8(), name: '客户洞察' },
        ],
        knowledgeIds: [],
        knowledgeNames: [],
        requestTipsUrl: isMaster
            ? 'http://nlb-eosibc0czx9wjua3kj.cn-shenzhen.nlb.aliyuncsslb.com:8000/chat-analysis/default-tips'
            : 'http://172.18.249.65:32058/chat-analysis/default-tips',
        requestConversationUrl: isMaster
            ? 'http://nlb-eosibc0czx9wjua3kj.cn-shenzhen.nlb.aliyuncsslb.com:8000/v1/chat-analysis/analyze-bizdata'
            : 'http://172.18.249.65:32058/v1/chat-analysis/analyze-bizdata',
    },
];

/** 系统内置智能体列表(与agentList合并后用于日志显示) */
const SystemAgentList = [
    { id: 'ai_designer', name: 'AI Designer' },
    { id: 'central_agent', name: '中枢智能体' },
    { id: 'text_processing_expert', name: '文本处理专家' },
    { id: 'approval_recommendation_agent', name: '审批建议智能体' },
    { id: 'form_filling_assistant', name: '填单助理' },
    { id: 'content_recognition', name: '内容识别' },
];

class AIAgentService {
    private readonly _agentMap: Map<string, H3.AI.AIAgent.IAgentModel> = new Map();

    private readonly _requestPromise: {
        loadAgentList?: Promise<H3.AI.AIAgent.IAgentModel[]>;
    } = {};

    /** 获取AI智能体开关状态 */
    private get _aiAgentEnabled() {
        return window.h3Daf?.Switch?.getSwitchStatusSync(H3.Operate.FunctionSwitchNameEnum.AIAgentEnable) ?? false;
    }

    /** 获取按钮调用AI智能体开关状态 */
    private get _buttonCallAIAgentEnable() {
        return (
            window.h3Daf?.Switch?.getSwitchStatusSync(H3.Operate.FunctionSwitchNameEnum.ButtonCallAIAgentEnable) ??
            false
        );
    }

    get agentMap() {
        return this._agentMap;
    }

    get agentList() {
        return Array.from(this._agentMap.values());
    }

    /** 外部智能体列表 */
    get externalAgentList() {
        return this.agentList.filter((agent) => agent.isExternal);
    }

    get systemAgentList() {
        return SystemAgentList;
    }

    /** 获取智能体列表 */
    async getAgentList(force = false) {
        if (force || this._agentMap.size === 0) {
            if (this._requestPromise.loadAgentList) {
                return this._requestPromise.loadAgentList;
            }
            this._requestPromise.loadAgentList = Promise.resolve(AgentList)
                .then((data) => {
                    this._agentMap.clear();
                    data.forEach((agent) => {
                        // 内置智能体受 _aiAgentEnabled 开关控制
                        if (!agent.isExternal && !this._aiAgentEnabled) {
                            return;
                        }
                        // 外部智能体受 _buttonCallAIAgentEnable 开关控制
                        if (agent.isExternal && !this._buttonCallAIAgentEnable) {
                            return;
                        }
                        this._agentMap.set(agent.id, agent);
                    });
                    return this.agentList;
                })
                .catch(() => {
                    return [];
                })
                .finally(() => {
                    this._requestPromise.loadAgentList = void 0;
                });
            return this._requestPromise.loadAgentList;
        }

        return this.agentList;
    }

    /** 根据智能体ID获取智能体信息 */
    async getAgentById(agentId: string) {
        await this.getAgentList();
        return this._agentMap.get(agentId) || null;
    }

    /** 清除缓存 */
    clearCache() {
        this._agentMap.clear();
        this._requestPromise.loadAgentList = void 0;
    }

    /** 刷新智能体列表缓存 */
    async refreshAgentList() {
        return this.getAgentList(true);
    }
}

export default new AIAgentService();
